import { __ } from '@wordpress/i18n';

const AddControl = ({ onClick, label = __('Add', 'progressmatify-blocks') }) => {
    return (
        <button onClick={onClick} className="progressmatify-add-btn">
            {/* <span className="dashicons dashicons-insert"></span> */}
            {label}
        </button>
    );
};

export default AddControl;
